/**
 * The frame every figure of round 3 (12 Oct 2026) sits in: a subtle Card with the figure
 * role, its title as the accessible name, the figure name as a data attribute for the
 * tests, and the caption under the content. The DS has no Figure component, so the frame
 * is composed here once and the five figures share it.
 */

import { Card, Typography } from "@norican/react";
import type { ReactNode } from "react";

export interface FigureProps {
  /** The registry name (`data-figure`), so a test or a style can find the figure. */
  name: string;
  /** The accessible name of the figure. */
  title: string;
  /** One sentence under the content, muted. */
  caption?: string;
  children: ReactNode;
}

export function Figure({ name, title, caption, children }: FigureProps) {
  return (
    <Card
      variant="subtle"
      padding="md"
      role="figure"
      aria-label={title}
      data-figure={name}
      className="flex min-w-0 flex-col gap-3"
    >
      {children}
      {caption && (
        <Typography variant="caption" tone="muted" className="break-words">
          {caption}
        </Typography>
      )}
    </Card>
  );
}
